export const Error = () => {
    return <h1>Sbrrr rakho yrrr kr raaa </h1>
}